import styled from "styled-components";

import { MainContainer } from "@/components/Layout/Styled";

export const StyledPMMainContainer = styled(MainContainer)`
    padding: 0;
`;
